import HeroComponent from '../components/hero';
/* global Back, Plyr */

export default class PodcastController {
  constructor(options) {
    this.options = options;
    console.log('PODCAST CONTROLLER');

    this.welfare_hero = new HeroComponent({
      elem      :'section.podcast__hero',
      parallaxCopy : true,
    });


      //const player = Array.from(document.querySelectorAll('.bbfpodcast')).map(p => new Plyr(p));


const player = Plyr.setup(".bbfpodcast" );

// Expose
window.player = player;

    for (var i in player) {
     player[i].on('play', function (instance) {
       var source = instance.detail.plyr.source;
       for (var x in player) {
         if (player[x].source != source) {
          player[x].pause();
         }
       }
     });
    }

  }


  handleResize() {
  }

  handleScroll() {
  }
}



// WEBPACK FOOTER //
// ./js/controllers/pages/PodcastController.js